import { module } from 'angular';
import templateBuilderKtableDisplay from './builder/display.html';
import templateBuilderKtableQuery from './builder/query.html';
import templateBuilderKtableValidate from './builder/validate.html';

export default module('app').run(/* @ngInject */ (
	/** @type {import('angular').ITemplateCacheService} */ $templateCache,
) => {
	$templateCache.put('kform/components/ktable/display.html', templateBuilderKtableDisplay);
	$templateCache.put('kform/components/ktable/query.html', templateBuilderKtableQuery);
	$templateCache.put('kform/components/ktable/validate.html', templateBuilderKtableValidate);
});
